<div [loadingOverlay]="isLoading()">
	<compose Selector="app-components-compositionroutegrid" [Model]="{ grid: grid }"></compose>
</div>